import React from "react";
import "./CasinoPaymentType.scss";
import { CASINO_URL_MENTIONS_LEGALES } from "app/constants";
import EcheancierCasinoContainer from "app/pages/Booking/Payment/Casino/EcheancierCasinoContainer";
import { FormattedMessage } from "react-intl";
import CasinoCustomerFieldset from "app/pages/Booking/Payment/Casino/CasinoCustomerFieldset";
import PropTypes from "prop-types";
import CreditCardPaymentType from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/creditCard/CreditCardPaymentType";

class CasinoPaymentType extends React.PureComponent {
	render() {
		const {
			field = { number: {} },
			payNowAmount,
			onCreditCardInputsBlur,
			onCreditCardInformationChange,
			showMaidenName,
		} = this.props;

		return (
			<div className="casino-payment-type">
				<div className="casino-payment-type__echeancier">
					<EcheancierCasinoContainer />
				</div>

				<CasinoCustomerFieldset
					maidenName={field.maidenName}
					birthdate={field.birthdate}
					zipCodeOfBirth={field.zipCodeOfBirth}
					showMaidenName={showMaidenName}
				/>

				<CreditCardPaymentType
					field={field}
					payNowAmount={payNowAmount}
					onCreditCardInputsBlur={onCreditCardInputsBlur}
					onCreditCardInformationChange={onCreditCardInformationChange}
				/>

				<div className="casino-payment-type__casino-more-info">
					<FormattedMessage
						id="payment.method.casino.data.protection.info.1"
						tagName="span"
					/>
					<FormattedMessage
						id="payment.method.casino.data.protection.info.2"
						tagName="span"
						values={{
							casinoURL: (
								<a
									rel="noopener noreferrer"
									target="_blank"
									href={CASINO_URL_MENTIONS_LEGALES}
								>
									<FormattedMessage id="payment.method.casino.data.protection.url.label" />
								</a>
							),
						}}
					/>
				</div>
			</div>
		);
	}
}

CasinoPaymentType.propTypes = {
	payNowAmount: PropTypes.number,
	field: PropTypes.object,
	showMaidenName: PropTypes.bool,
	onCreditCardInputsBlur: PropTypes.func,
	onCreditCardInformationChange: PropTypes.func,
};

export default CasinoPaymentType;
